export const jhcassoAPIUri = {

  // ==============================
  // 🔐 AUTH APIs
  // ==============================
  requestOtp: "auth/u/sendotp",
  verifyOtp: "auth/u/verifyotp",
  resendotp: "auth/u/resendotp",
  refreshToken: "auth/u/refreshtoken",
  logout: "auth/u/logout",

  // ==============================
  // 👤 USER PROFILE APIs
  // ==============================
  profile: "users/profile",
  editProfile: "users",
  devicetoken: "users/device-token",
  phoneUpdate: "",
  email: "verify/email",
  verifyemail: "verify/email",

  // ==============================
  // 📍 ADDRESS APIs
  // ==============================
  address: "address",
  // ==============================
  // 🏪 SALON & SEARCH APIs
  // ==============================
  salon: "salon/",
  search: "salon/search",
  searchbycat: "salon/search/bycat",

  // ==============================
  // 🎟 BOOKING & TIMESLOT APIs
  // ==============================
  validate: "timeslot/validate",
  booking: "booking",
  checkavailability: "booking/checkavailability",
  appointment: "appointment/history",
  singleAppointment: "appointment",

  // ==============================
  // ⭐ REVIEW APIs
  // ==============================
  review: "review",

  // ==============================
  // 🎁 OFFERS & COUPONS APIs
  // ==============================
  offers: "offers",
  coupons: "offers/coupons",
  checkcoupon: "coupon/validate",

  // ==============================
  // 📊 DATA APIs
  // ==============================
  banners: "data/banners",
  categories: "data/categories",
  settings: "data/app/settings",
  sharedsettings: "data/app/sharedsettings",

  // ==============================
  // 📰 BLOG APIs
  // ==============================
  blog: "blog",
  blogDetail: "blog/", // trailing slash handled in API call if needed

  // ==============================
  // 🔔 NOTIFICATION APIs
  // ==============================
  notification: "notification",
  notificationSettings: "notification/settings",

  // ==============================
  // 🎫 SUPPORT / TICKETS APIs
  // ==============================
  ticketstypes: "support/tickets/types",
  addtickets: "support/tickets",
  ticket: "support/tickets",
  pmsTaskUri: "support/tickets",
  usertickets: "support/tickets/history"
};